import React from "react";

const RoadmapOwnerCell = (props) => {
    return <>
        {props.item.appliesTo === "CLIENT" && <span>Client</span>}
        {props.item.appliesTo === "CO_CLIENT" && <span>Spouse</span>}
        {props.item.appliesTo === "SPOUSE" && <span>Spouse</span>}
        {props.item.appliesTo === "JOINT" && <span>Joint</span>}
        {props.item.appliesTo === "TRUST" && <span>Trust - {props.item.trustName}</span>}
    </>
};

export default RoadmapOwnerCell;
